<p-toast></p-toast>

<div class="app-card">
  <div class="flex flex-col gap-5 xl:flex-row xl:items-center xl:justify-between">
    <div class="flex flex-col items-center w-full gap-6 xl:flex-row">
      <div class="relative w-20 h-20">
        <div class="w-20 h-20 overflow-hidden border border-gray-200 rounded-full dark:border-gray-800" [ngClass]="{'ring-4 ring-brand-500': showPreview}">
          @if (previewUrl) {
            <img [src]="previewUrl" [alt]="getNombreCompleto()" class="w-full h-full object-cover" />
          } @else if (avatarUrl) {
            <img [src]="avatarUrl | authImage | async" [alt]="getNombreCompleto()" class="w-full h-full object-cover" />
          } @else {
            <img [src]="placeholderAvatarUrl" [alt]="getNombreCompleto()" class="w-full h-full object-cover" />
          }
        </div>
        @if (!showPreview) {
          <button
            (click)="triggerFileInput()"
            [disabled]="isUploading"
            class="absolute bottom-0 right-0 flex h-7 w-7 items-center justify-center rounded-full border-2 border-white bg-brand-500 text-white shadow-md hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed dark:border-gray-800"
            title="Cambiar avatar"
          >
            @if (isUploading) {
              <svg class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            } @else {
              <svg class="fill-current" width="14" height="14" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M15.0911 2.78206C14.2125 1.90338 12.7878 1.90338 11.9092 2.78206L4.57524 10.116C4.26682 10.4244 4.0547 10.8158 3.96468 11.2426L3.31231 14.3352C3.25997 14.5833 3.33653 14.841 3.51583 15.0203C3.69512 15.1996 3.95286 15.2761 4.20096 15.2238L7.29355 14.5714C7.72031 14.4814 8.11172 14.2693 8.42013 13.9609L15.7541 6.62695C16.6327 5.74827 16.6327 4.32365 15.7541 3.44497L15.0911 2.78206ZM12.9698 3.84272C13.2627 3.54982 13.7376 3.54982 14.0305 3.84272L14.6934 4.50563C14.9863 4.79852 14.9863 5.2734 14.6934 5.56629L14.044 6.21573L12.3204 4.49215L12.9698 3.84272ZM11.2597 5.55281L5.6359 11.1766C5.53309 11.2794 5.46238 11.4099 5.43238 11.5522L5.01758 13.5185L6.98394 13.1037C7.1262 13.0737 7.25666 13.003 7.35947 12.9002L12.9833 7.27639L11.2597 5.55281Z" fill=""/>
              </svg>
            }
          </button>
        }
        <input
          type="file"
          id="avatar-upload"
          accept="image/jpeg,image/png,image/gif,image/webp"
          (change)="onFileSelected($event)"
          class="hidden"
        />
      </div>
      <div class="flex-1">
        <h4 class="mb-2 text-lg font-semibold text-center text-gray-800 dark:text-white/90 xl:text-left">
          {{ getNombreCompleto() }}
        </h4>
        <div class="flex flex-col items-center gap-1 text-center xl:flex-row xl:gap-3 xl:text-left">
          <p class="text-sm text-gray-500 dark:text-gray-400">
            {{ getRoles() }}
          </p>
          @if (usuario.email) {
            <div class="hidden h-3.5 w-px bg-gray-300 dark:bg-gray-700 xl:block"></div>
            <p class="text-sm text-gray-500 dark:text-gray-400">
              {{ usuario.email }}
            </p>
          }
        </div>
        
        @if (showPreview) {
          <div class="flex items-center justify-center gap-3 mt-4 xl:justify-start">
            <button
              (click)="confirmUpload()"
              [disabled]="isUploading"
              class="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-brand-500 rounded-lg hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              @if (isUploading) {
                <svg class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <span>Subiendo...</span>
              } @else {
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                </svg>
                <span>Confirmar</span>
              }
            </button>
            <button
              (click)="cancelUpload()"
              [disabled]="isUploading"
              class="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors dark:bg-gray-800 dark:text-gray-300 dark:border-gray-700 dark:hover:bg-gray-700"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
              <span>Cancelar</span>
            </button>
          </div>
        }
      </div>
    </div>
  </div>
</div>
